<template>
  <div class="signup-form">
    <form
      ref="form"
      class="form-group"
      novalidate
      @submit="handleSubmit"
    >
      <label
        className="form-group__label text-utility-label-s"
        htmlFor="newsletter-email"
        v-text="$string('general.newsletter.email')"
      />

      <div className="form-group__field signup-form__field">
        <div class="signup-form__input-and-submit">
          <input
            id="newsletter-email"
            v-model="emailAddress"
            class="text-body-m"
            name="email"
            :placeholder="$string('general.newsletter.placeholder')"
            type="email"
          >

          <input
            name="g"
            type="hidden"
            :value="$variable('credentials.klaviyo.marketingListId')"
          >

          <btn
            block-class="signup-form"
            class="signup-form__submit"
            :disabled="state === 'submitting' || state === 'success'"
            :display-label="false"
            :label="
              state === 'success'
                ? $string('accessibility.success')
                : $string('general.newsletter.submit_label')
            "
            modifiers="text"
            show-icon
            type="submit"
          >
            <template #icon>
              <icon-chevron-right />
            </template>
          </btn>
        </div>

        <div class="signup-form__message">
          <p
            v-if="emailError"
            class="signup-form__error text-body-s"
            v-text="emailError"
          />

          <p
            v-if="state === 'success'"
            class="signup-form__error text-body-s"
            v-text="$string('general.newsletter.success_message')"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>

/**
 * Vue: Signup form (signup-form)
 * -----------------------------------------------------------------------------
 * Signup form for email marketing.
 *
 */
import subscribe from '~/api/klaviyo'
import { formatKlaviyoData } from '~/helpers/format'

import Btn from '~global/btn/btn'

import IconChevronRight from '~icons/direction/chevron/right.svg'

export default {
  name: 'SignupForm',

  components: {
    Btn,
    IconChevronRight,
  },

  data() {
    return {
      emailAddress: null,
      emailError: null,
      state: 'ready',
    }
  },

  computed: {

    /**
     * Test whether the email address contains '@' and '.' symbols.
     * - A simple regex test is used, to avoid blocking valid email addresses.
     * - The `type="email"` attribute on the input element allows for email
     *   validation in most modern browsers.
     * @returns {Boolean}
     */
    emailIsValid() {
      return (/\S+@\S+\.\S+/).test(this.emailAddress)
    },
  },

  methods: {

    /**
     * Handle form submission events.
     * @param {Event} event - submit event.
     */
    handleSubmit(event) {
      event.preventDefault()

      this.emailError = null
      this.state = 'submitting'

      if (!this.emailIsValid) {
        this.emailError = this.$string('general.newsletter.error_email')
      }

      if (
        this.emailError
      ) {
        this.state = 'error'
        return
      }

      const data = formatKlaviyoData(new FormData(this.$refs.form))

      subscribe(data)
        .then(() => {
          this.state = 'success'
        })
        .catch(() => {
          this.state = 'error'
          this.emailError =
            this.$string('general.newsletter.error_generic')
        })
    },
  },
}
</script>

<style lang="scss">
@import './signup-form';
</style>
